<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li *ngFor="let breadcrumb of breadcrumbs">
      <span>
        <a href="/home">Home </a>
        <span>></span>

        <span *ngIf="breadcrumb.keyUrl && !breadcrumb.splUrl">
          <a href="{{ breadcrumb.url }}"> {{ breadcrumb.label }} </a>
          <span>></span>
          <span> {{ breadcrumb.key }}</span>
        </span>
        <span *ngIf="breadcrumb.keyUrl && breadcrumb.splUrl">
          <a href="{{ breadcrumb.url }}"> {{ breadcrumb.label }} </a>
          <span>></span>
          <span *ngIf="breadcrumb.key != undefined">
            <a href="{{ breadcrumb.splUrl }}"> {{ breadcrumb.splKey }} </a>
            <span>></span>
          </span>
          <span *ngIf="breadcrumb.key == undefined">
            <span>{{ breadcrumb.splKey }}</span>
          </span>
          <span> {{ breadcrumb.key }}</span>
        </span>
        <span *ngIf="!breadcrumb.keyUrl">
          <span> {{ breadcrumb.label }} </span>
        </span>
      </span>
    </li>
  </ol>
</nav>
